import React, {Children} from 'react';

import {Group} from '@pb/kit-component-group';

const DEFAULT_PADDING = '0 32px 16px 0';

type Props = {
    padding?: string,
    children?: React.ReactNode,
};

export const ResponsiveElementGroup = ({children, padding = DEFAULT_PADDING}: Props) => (
    <Group wrap="wrap" alignItems="start" gap="none">
        {children ? Children.map(children, (child, index) => (
            child ? <div key={index} style={{padding}}>{child}</div> : null
        )) : null}
    </Group>
);
